// 引入vue
import Vue from 'vue'
// 引入i18n语言包
import VueI18n from 'vue-i18n'
// 引入定义好的中英文语言
import messages from './lang'
// 引入element语言切换:
import locale from 'element-ui/lib/locale'

/**
 *  pp组件未提供国际化语言包，引入iview，作兼容。
 */

import iView from 'view-design'

// 在vue中使用i18n
Vue.use(VueI18n)

const normalizeLang = lang => {
	const value = (lang || '').toLowerCase()
	if (value.includes('zh')) return 'zh'
	if (value.includes('ja')) return 'ja'
	if (value.includes('en')) return 'en'
	return ''
}

const getLang = () => {
	const localLang = normalizeLang(localStorage.getItem('lang'))
	const navigatorLang = normalizeLang(navigator.language)

	if (!localStorage.getItem('lang')) {
		localStorage.setItem('lang', navigatorLang || 'en')
	}

	return localLang || navigatorLang || 'en'
}

// 初始化设置默认语言
const i18n = new VueI18n({
	locale: getLang(),
	messages
})
// console.log(555,i18n)
Vue.use(iView)
locale.i18n((key, value) => i18n.t(key, value))
export default i18n
